export const CORE_DATE_PARAM = 'date';
export const ISO_DATE_FORMAT = 'YYYY-MM-DD';

export const CORE_SEATS_PARAM = 'seats';
export const CORE_SEATS_DEFAULT = 2;
export const CORE_SEATS_INIT_MAX = 20;
export const CORE_SEATS_INIT_MIN = 1;
export const CORE_SEATS_LOWER_MIN = 1;
export const CORE_SEATS_UPPER_MAX = 1000;

export const CORE_TIME_PARAM = 'time';
export const ALL_DAY = 'all-day';
